import Vue from 'vue'
import VueRouter from "vue-router"
Vue.use(VueRouter);

import Dashboard from "@/views/Dashboard"

const routes = [
    {
        path: '/',
        name: 'Login',
        component: () => import(/* webpackChunkName: "Login" */ '../views/Login.vue')
    },
    {
        name: "Dashboard",
        path: '/dashboard',
        component: Dashboard
    },
    {
        path: '*',
        redirect: '/'
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})
export default router